<template>
  <div class="wrapper-plans">
    <BaseSkeletonLine class="skeleton" />
    <div class="plans">
      <PlanSkeleton />
      <PlanSkeleton />
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";

import BaseSkeletonLine from "@/components/base/BaseSkeletonLine.vue";
import PlanSkeleton from "@/components/settings/PlanSkeleton.vue";

export default defineComponent({
  components: { BaseSkeletonLine, PlanSkeleton },
});
</script>
<style lang="scss" scoped>
.plans {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
}

.skeleton {
  margin: 8px 0 4px 0;
  width: 140px;
}
</style>
